import React from "react";
import { Box } from "@mui/material";
import styles from "./ModalFooter.styles";
import { modalTypes } from "../../../constants/field-constants";
import DefaultButton from "../../button/Button";

interface ModalFooterProps {
  closeModal: any;
  type: string;
  onSave?: any;
  disabled?: boolean;
  handleClear?: any;
}

export default function ModalFooter({
  onSave = () => {},
  closeModal = () => {},
  handleClear = () => {},
  ...props
}: ModalFooterProps) {
  return (
    <Box sx={styles.intervalInput}>
      {props.type === modalTypes.CREATE ||
      props.type === modalTypes.SAVE ||
      props.type === modalTypes.UPDATE ? (
        <>
          <DefaultButton
            {...props}
            disabled={props.disabled}
            variant="contained"
            styleType="save"
            handleClick={() => {
              onSave();
              // closeModal();
            }}
          >
            Save
          </DefaultButton>
          <DefaultButton
            variant="contained"
            styleType="cancel"
            handleClick={() => {
              handleClear();
              closeModal();
            }}
          >
            Cancel
          </DefaultButton>
        </>
      ) : props.type === modalTypes.DELETE ? (
        <>
          <DefaultButton
            variant="contained"
            styleType="delete"
            handleClick={() => {
              onSave();
              closeModal();
            }}
          >
            Delete
          </DefaultButton>
          <DefaultButton
            variant="contained"
            styleType="cancel"
            handleClick={closeModal}
          >
            Cancel
          </DefaultButton>
        </>
      ) : props.type === modalTypes.UNLINK ? (
        <>
          <DefaultButton
            variant="contained"
            styleType="unlink"
            handleClick={() => {
              onSave();
              closeModal();
            }}
          >
            Unlink
          </DefaultButton>
          <DefaultButton
            variant="contained"
            styleType="cancel"
            handleClick={closeModal}
          >
            Cancel
          </DefaultButton>
        </>
      ) : (
        <DefaultButton
          variant="contained"
          styleType="close"
          handleClick={closeModal}
        >
          Close
        </DefaultButton>
      )}
    </Box>
  );
}
